var $ = jQuery.noConflict()

$(document).ready(function() {

	Reveals.init();
	Midnight.init();
	Menu.init();	
	FullHeight.init();

	if(Config.debug_mode == true){
		Debug.init();	
	}

	var template = $('#content').attr('data-template');
	//Debug.log("TEMPLATE : " + template);
	switch(template){
		case "homepage":

			break;
		default:

			break;
								 }


});